import React, {Component} from 'react';

import GroupModalForm from './GroupModalForm'

class GroupLinkUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const {group} = this.props
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {Name, MoreInfo} = values
      const desc = MoreInfo.desc
        ? MoreInfo.desc
        : ""
      const jsonString = JSON.stringify({desc: desc})
      const info = btoa(unescape(encodeURIComponent(jsonString)))
      const updateGroup = {
        ...group,
        Name: Name,
        MoreInfo: info
      }
      this.props.onUpdate(updateGroup)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {group, groups} = this.props
    const title = `Cập nhật thông tin địa bàn [${group.Name}]`
    return (<span>
      <a onClick={this.showModal}>Sửa thông tin</a>
      <GroupModalForm title={title} group={group} groups={groups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default GroupLinkUpdate;



// WEBPACK FOOTER //
// ./src/components/GroupLinkUpdate.js